/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page-profile[_ngcontent-%COMP%]{padding:15px 0}.page-profile[_ngcontent-%COMP%]   .profile-brand[_ngcontent-%COMP%]{margin:25px 0}"];
export { styles as styles };
